import React from "react";
import {Columns,} from 'bloomer'
import ProfileItem from './profile-item'
import ProfileItemSmall from './profile-item-2'
import PropTypes from "prop-types";

const Component = ({profiles,onClick,defaultImage,isLargeMode}) => {
  return (<Columns isMultiline>{
    Array.isArray(profiles) &&
    profiles.map((profile, index) => (
      (isLargeMode) ?
        <ProfileItem key={index}
                     profile={profile}
                     defaultImage={defaultImage}
                     onClick={onClick}
        /> :
        <ProfileItemSmall key={index}
                          defaultImage={defaultImage}
                          profile={profile}
                          onClick={onClick}
        />
    ))
    }
    </Columns>
  );
};

Component.propTypes = {
  profiles:PropTypes.array,
  onClick:PropTypes.func,
  defaultImage: PropTypes.shape({
    alt:PropTypes.string,
    src:PropTypes.string
  }),
  isLargeMode:PropTypes.bool
};
Component.defaultProps = {
};

export default Component;
